var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-live",
    transform: "translate(-6718.17 -155.763)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    transform: "translate(6718.17 155.763)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M6891.169-3496.643a10.8,10.8,0,0,1,11-10.6,10.8,10.8,0,0,1,11,10.6,10.8,10.8,0,0,1-11,10.594A10.8,10.8,0,0,1,6891.169-3496.643Zm8.094,8.135a14.082,14.082,0,0,1-2.066-7.135h-3.967A8.719,8.719,0,0,0,6899.264-3488.508Zm5.816,0a8.718,8.718,0,0,0,6.033-7.135h-3.967A14.077,14.077,0,0,1,6905.08-3488.508Zm-4.654-1.958c.63,1.26,1.331,1.823,1.745,1.823s1.118-.564,1.747-1.823a13.655,13.655,0,0,0,1.227-5.177H6899.2A13.655,13.655,0,0,0,6900.426-3490.466Zm10.688-7.177a8.716,8.716,0,0,0-6.033-7.134,14.076,14.076,0,0,1,2.066,7.134Zm-5.969,0a13.655,13.655,0,0,0-1.227-5.176c-.629-1.26-1.331-1.823-1.747-1.823s-1.115.564-1.745,1.823a13.646,13.646,0,0,0-1.226,5.176Zm-7.947,0a14.077,14.077,0,0,1,2.066-7.134,8.716,8.716,0,0,0-6.033,7.134Z",
    transform: "translate(-172.002 3664.406)",
    fill: "#222a41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/icon_live.96ef07a6.svg";
export { ForwardRef as ReactComponent };